module.exports = __webpack_public_path__ + "img/btDoubt.0635ea6d.gif";